<template>
  <div class="list-grid col-12 mt-3">
    <!-- row number -->
    <div v-for="row in Math.ceil(data.length/columnNumber)" v-bind:key="row">
      <div class="row">
        <div class="grid-item col-3 p-2" v-bind:class="{'col-3': columnNumber > 4, 'col-4' : columnNumber < 4}"  v-for="column in columnNumber" v-bind:key="column">
          <div class="item-wrap" v-if="getIndexData(row, column) < data.length">
            <div class="item-thumb">
              <a :href="`#/ip-view/${data[getIndexData(row, column)].id}`">
                <div
                  class="ip-thumb"
                  v-bind:style="{background: 'url(\'' + getIdeaLogo(data[getIndexData(row, column)].slideShow) + '\')'}"
                ></div>
              </a>
            </div>
            <div class="item-body">
              <a
                class="grid-title"
                :href="`#/ip-view/${data[getIndexData(row, column)].id}`"
              >{{data[getIndexData(row, column)].title}}</a>
              <div class="item-description">{{data[getIndexData(row, column)].summary}}</div>
            </div>
            <div class="item-bottom col-12">
              <div class="wrap">
                <div>
                  <div class="item-top">
                    <div class="item-author">{{data[getIndexData(row, column)].ideaAuthor}}</div>
                    <span class="footer_dot">
                    <i class="fa fa-circle"></i>
                  </span>
                    <div class="time">{{data[getIndexData(row, column)].createdTime | fromNow}}</div>
                  </div>
                </div>
                <div class="row p-3" >
                  <div class="tag-item level" v-if="getMedalName(data[getIndexData(row, column)])"
                  >{{getMedalName(data[getIndexData(row, column)])}}</div>
                  <div
                    class="tag-item confidential"
                    v-if="data[getIndexData(row, column)].companyName"
                    @click="setCompany(data[getIndexData(row, column)])"
                  >{{data[getIndexData(row, column)].companyName}}</div>
                  <div
                    class="tag-item"
                    v-if="data[getIndexData(row, column)].ideaType"
                    @click="setType(data[getIndexData(row, column)])"
                  >{{data[getIndexData(row, column)].ideaType | getTypeDataName}}</div>
                </div>
                <!-- <div
                  v-for="(tag, index) in data[getIndexData(row, column)].tags"
                  class="tag-item"
                  :key="index"
                  @click="setTechType(tag)"
                >{{ tag.name }}</div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import "moment/locale/vi";

import * as CONFIG from "@/config/index.js";
import helper from "../../common/helper";
import ideaLogo from "../../assets/images/sangkien/logo-iKhien.png";
import { ipType } from "../const/ipType";

export default {
  name: "ListGrid",
  components: {},
  props: {
    columnNumber: {
      type: Number,
      required: true
    },
    itemClass: {
      type: String,
      required: false
    },
    data: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      ideaLogo: ideaLogo
    };
  },
  filters: {
    getTypeDataName(typeCode) {
      if (!typeCode) {
        return "";
      }
      const type = ipType.find(p => p.code === typeCode);
      if (type) {
        return type.name;
      }

      return "";
    },
    fromNow: function(time) {
      return moment(time).fromNow();
    }
  },
  mounted() {
    this.$moment.locale("vi");
  },
  methods: {
    setTechType(tech) {
      localStorage.setItem("tech", JSON.stringify(tech));
      window.location.href = `${CONFIG.CLIENT_URL}/#/advanced-search/`;
    },
    setType(item) {
      localStorage.setItem("search-type", item.ideaType);
      window.location.href = `${CONFIG.CLIENT_URL}/#/browse-ip/sangkien`;
    },
    setCompany(item) {
      const data = {
        name: item.companyName,
        code: item.companyCode
      };
      localStorage.setItem("search-company", data.code);
      window.location.href = `${CONFIG.CLIENT_URL}/#/browse-ip/sangkien`;
    },
    formatDateTime: function(time) {
      return moment(time).fromNow();
    },
    getThumbnail(item) {
      let { thumb } = item;
      if (!thumb) {
        return `${CONFIG.CLIENT_URL}/static/img/Login_computer.b246d6e.png`;
      }
      return CONFIG.API_URL + "/image/" + thumb.split(",")[0];
    },
    getMedal(item) {
      return helper.getMedal(
        item.masterIdIPType,
        item.statusSonar,
        item.statusJenkins,
        item.statusCoverity
      );
    },
    getIndexData(row, col) {
      return col + this.columnNumber * (row - 1) - 1;
    },
    getIdeaLogo(image) {
      if (!image) {
        return ideaLogo;
      }

      const images = image.split(",");
      if (images && images.length > 0) {
        return `${CONFIG.API_URL}/image/${images[0]}`;
      }
      return ideaLogo;
    },
    getMedalName(idea) {
      try {
        if (!idea.medal && !idea.yearReward) {
          return "";
        }

        if(idea.yearReward && (idea.yearReward == 1 || idea.yearReward == 2)){
           return idea.yearReward == 1? "Sáng tạo của năm":"Giải nhì năm";
        } else {
          return idea.medalName;
        }
      } catch (error) {
        return "";
      }
    },
  }
};
</script>
<style scoped>
.list-grid div[class*="col"] {
  padding-right: 10px;
  padding-left: 10px;
  margin-bottom: 15px;
}

.list-grid .row {
  margin-right: -10px;
  margin-left: -10px;
}
.grid-item .item-wrap {
  box-shadow: 0px 2px 5px 2px rgba(0, 0, 0, 0.16);
  border-radius: 4px;
  overflow: hidden;
  background-color: #fff;
  height: 430px;
}

.grid-item .item-wrap .item-top {
  display: flex !important;
  flex-direction: row;
  align-items: center;
  height: 33px;
  max-height: 32px;
  text-overflow: ellipsis;
  display: -webkit-inline-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-break: break-word;
  text-align: left;
}

.grid-item .item-wrap .item-bottom {
  background-color: #f6fbfb;

  padding: 10px 15px 15px;
}

.grid-item .item-wrap .wrap {
  flex-wrap: wrap;
  display: flex;
  height: 110px;
  overflow: hidden;
}

.grid-item .item-wrap .item-bottom .tag-item {
  padding-top: 1px !important;
  border: 1px solid #0855dc00;
  color: #3199bb !important;
  font-size: 10px !important;
  background: #e3e9f0;
  margin-top: 5px !important;
  /* margin-right: 5px !important; */
  border-radius: 10px;
  height: 19px;
  padding: 2px 5px;
  cursor: pointer;
}

.grid-item .item-wrap .item-bottom .tag-item.level {
  background: #3199bb !important;
  color: #fff !important;
  text-transform: uppercase;
  margin-right: 3px;
}

.grid-item .item-wrap .item-bottom .tag-item.confidential {
  background: #0855dc00;
  border: 1px solid #3199bb;
  margin-right: 3px;
}

.grid-item .item-wrap .item-top .item-author {
  font-weight: 700;
  font-size: 12px;
  margin-left: 4px;
  overflow: hidden;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  word-break: break-all;
  max-width: 60%;
}

.grid-item .item-wrap .item-top .footer_dot {
  font-size: 6px;
  margin: 2px 6px 0 6px;
}

.grid-item .item-wrap .item-top .time {
  font-size: 11px;
}

.grid-item .item-wrap .item-body {
  padding: 0 15px;
  height: 110px;
}

.grid-item .item-wrap .item-body .item-title {
  font-size: 16px;
  text-align: left;
  color: #3299ba;
  line-height: 1.44;
  letter-spacing: 0.13px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  word-break: break-all;
}

.grid-item .item-wrap .item-body .item-description {
  font-size: 13px;
  line-height: 1.33;
  letter-spacing: 0.06px;
  text-align: left;
  color: #1e242f;
  margin-top: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-break: break-word;
  height: 36px;
}

.grid-item .item-wrap .item-thumb {
  height: 200px;
  background-size: cover;
  position: relative;
}

.grid-item .item-wrap .item-thumb .view-download {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 35px;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.15) 33%,
    rgba(0, 0, 0, 0.3) 66%,
    rgba(0, 0, 0, 0.45) 100%
  );
  color: #fff;
  padding-left: 12px;
  font-size: 12px;
  padding-top: 10px;
}

.list-grid .b-pagination {
  margin-left: auto;
  margin-right: 7px;
}

.item-thumb:hover {
  opacity: 0.7;
  cursor: pointer;
}
.item-title:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/ListGrid.vue